// extracted by mini-css-extract-plugin
module.exports = {"avatarDefaultBackground":"AvatarWithName_avatarDefaultBackground__1bEOU"};